"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Button;

var _ButtonModule = _interopRequireDefault(require("../../assets/styles/components/Button.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Button(_ref) {
  let {
    children,
    onClick: _onClick,
    size = "default",
    styling = {},
    shape = "default",
    isLoading = false,
    disabled = false,
    kind = "primary"
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
    onClick: e => {
      _onClick(e);
    },
    className: "\n                ".concat(_ButtonModule.default.button, " \n                ").concat(size === "large" ? _ButtonModule.default.size_large : size === "default" ? _ButtonModule.default.size_default : size === "compact" ? _ButtonModule.default.size_compact : size === "mini" ? _ButtonModule.default.size_mini : _ButtonModule.default.size_default, "\n                ").concat(shape === "default" ? _ButtonModule.default.shape_default : shape === "pill" ? _ButtonModule.default.shape_pill : shape === "round" ? _ButtonModule.default.shape_round : shape === "circle" ? _ButtonModule.default.shape_circle : shape === "square" ? _ButtonModule.default.shape_square : _ButtonModule.default.shape_default, "\n                ").concat(kind === "primary" ? _ButtonModule.default.color_primary : kind === "secondary" ? _ButtonModule.default.color_secondary : kind === "plain" ? _ButtonModule.default.color_plain : _ButtonModule.default.color_primary, "\n            "),
    style: styling,
    disabled: disabled,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: isLoading ? {
        height: "0px",
        opacity: 0
      } : {},
      children: children
    }), isLoading && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: kind === "primary" ? _ButtonModule.default.loader : kind === "secondary" ? _ButtonModule.default.loader_secondary : _ButtonModule.default.loader
    })]
  });
}